import * as React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Styles from './index.styles';

import { useId } from '../../../Utils/Hooks';
import { Popover } from '../../Popover';

const { StyledLabel, StyledHelperContainer } = Styles;

export const DisplayInputsHeader = ({ id, text, disabled, helperContent }) => {
    const [open, setOpen] = React.useState(false);

    const [headerId] = useId('display-header', id);

    return (
        <>
            <StyledLabel>
                {text}
                {helperContent && !disabled && (
                    <StyledHelperContainer
                        id={`helper-button${headerId}`}
                        data-test-id="help-btn"
                        onClick={() => setOpen(prev => !prev)}
                    >
                        <FontAwesomeIcon icon={['fas', 'info']} />
                    </StyledHelperContainer>
                )}
                {helperContent && (
                    <Popover
                        bindTo={`helper-button${headerId}`}
                        open={!disabled && open}
                        onClose={() => setOpen(false)}
                        width="300px"
                        enableMobile
                        darkMode
                    >
                        <div data-test-id="help-content">{helperContent}</div>
                    </Popover>
                )}
            </StyledLabel>
        </>
    );
};

DisplayInputsHeader.propTypes = {
    id: PropTypes.string,
    text: PropTypes.string.isRequired,
    disabled: PropTypes.string,
    helperContent: PropTypes.node,
};

DisplayInputsHeader.defaultProps = {
    id: '',
    disabled: false,
    helperContent: null,
};

export default DisplayInputsHeader;
